<template>
  <div class="comic-poster-container">
    <div class="frame-bg"></div>
    <div ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in picList" :key="index" class="swiper-slide">
          <div
            v-if="item.url"
            class="swiper-slide-link"
            @click="jumpDetail(item.url)"
            v-rseat="`click_carnival_banner_${index}`"
          >
            <img class="swiper-lazy" :data-src="item.img" />
          </div>
          <img v-else class="swiper-lazy" :data-src="item.img" />
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    </div>
    <div ref="pagination" class="swiper-pagination" v-if="picList.length > 1"></div>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export default {
  props: {
    picList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiper: null,
    }
  },
  methods: {
    initSwiper() {
      if (!this.swiper) {
        const config = {
          initialSlide: 0,
          slidesPerView: 1,
          centeredSlides: true,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          lazy: {
            loadPrevNext: true,
          },
        }
        if (this.picList.length > 1) {
          Object.assign(config, {
            autoplay: true,
            loop: true,
            pagination: {
              el: this.$refs.pagination,
            },
          })
        }
        this.swiper = new Swiper(this.$refs.swiper, config)
      }
    },
    jumpDetail(url) {
      window.open(url)
    },
  },
  mounted() {
    this.initSwiper()
  },
}
</script>
<style lang="less" scoped>
.comic-poster-container {
  position: absolute;
  width: 100%;
  height: 282px;
  /deep/ .frame-bg {
    width: 1072px;
    height: 254px;
    background: transparent url('~@/assets/carnival2020/main-kv/swiper-container.png') center center no-repeat;
    background-size: cover;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  /deep/ .swiper-container {
    width: 1057px;
    height: 229px;
    top: 18px;
    img {
      width: 1057px;
      height: 229px;
      // object-fit: cover;
    }
  }
  /deep/ .swiper-pagination {
    width: 100%;
    font-size: 0;
    bottom: 0;
    .swiper-pagination-bullet {
      width: 60px;
      height: 8px;
      background: transparent url('~@/assets/carnival2020/main-kv/pagination-bullet.png') center center no-repeat;
      background-size: cover;
      margin: 0 1px;
      opacity: 1;
      border-radius: 0;
      &.swiper-pagination-bullet-active {
        background: transparent url('~@/assets/carnival2020/main-kv/pagination-bullet-active.png') center center
          no-repeat;
        background-size: cover;
      }
    }
  }
  .swiper-slide-link {
    display: block;
  }
}
</style>
